module.exports = __webpack_public_path__ + "img/empresa_vivo_faturas_envio_clientes3.ad2ebc98.jpg";